import "brace/mode/html";
import "brace/theme/clouds";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import { Button } from 'react-bootstrap';
import { toast } from "react-toastify";
import * as Yup from "yup";
import FormikInputControl from '../Shared/Forms/FormikInputControl';
import { request, requestWithLoadingTimeout } from "../utils/axios";

const Template = ({ match: { params: { id } }, ...props }) => {
  const [recordState, setRecordState] = useState({ template: null, loadingInProgress: true })

  const validationSchema = Yup.object().shape({
    key: Yup.string().required('is required').max(50, "maximum 50 characters"),
    base_template: Yup.string().required('is required').max(100, "maximum 100 characters"),
    subject: Yup.string().required('is required').max(100, "maximum 100 characters"),
    description: Yup.string().max(500, "maximum 50 characters"),
    from_name: Yup.string().required('is required').max(100, "maximum 100 characters"),
    from_email: Yup.string().required('is required').max(100, "maximum 100 characters").email("doesn't look like a valid email address"),
    html_content: Yup.string().required('must have HTML content').max(50000, "maximum 50000 characters"),
    deal_id: Yup.number('must be a number')
  });

  const getTemplate = () => {
    if (id === 'new') return setRecordState({ ...recordState, template: { base_template: 'default_template' }, html_content: '<p>Content here</p>' })
    requestWithLoadingTimeout(
      { method: "get", url: `/admin/templates/${id}` },
      () => setRecordState({ ...recordState, loadingInProgress: true }),
      (response) => {
        setRecordState({ ...recordState, template: response, html_content: response.html_content, loadingInProgress: false })
      },
      (error) => setRecordState({ ...recordState, loadingInProgress: false })
    )
  }

  const sendTest = (values) => {
    const toastId = toast("Sending Test email using the current template", { type: toast.TYPE.INFO, autoClose: false })
    requestWithLoadingTimeout(
      { method: "post", url: `/admin/templates/send_test`, data: { template: values } },
      () => setRecordState({ ...recordState, loadingInProgress: true }),
      (response) => {
        toast.update(toastId, { render: 'Sent template test to your email', type: toast.TYPE.SUCCESS, autoClose: 3000 });
      },
      (error) => {
        toast.update(toastId, { render: `There were some problems, we couldn't send your Template - please check the syntax (${error.data})`, type: toast.TYPE.ERROR, autoClose: 10000 });
        setRecordState({ ...recordState, loadingInProgress: false })
      }
    )
  }

  useEffect(() => { getTemplate() }, [id]);

  if (!recordState.template) return null

  return (

    <Formik
      isInitialValid={true}
      initialValues={{
        key: recordState.template.key || "",
        base_template: recordState.template.base_template || "",
        subject: recordState.template.subject || "",
        description: recordState.template.description || "",
        from_name: recordState.template.from_name || "",
        from_email: recordState.template.from_email || "",
        html_content: recordState.html_content || '',
        owner_id: undefined,
        deal_id: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        const toastId = toast("Saving template", { type: toast.TYPE.INFO, autoClose: false })
        const update = recordState.template.id && recordState.template.id !== 'new'
        const save = update ? request({ method: "patch", url: `/admin/templates/${recordState.template.id}`, data: { template: values } }) : request({ method: "post", url: `/admin/templates`, data: { template: values } })
        save.then(response => {
          toast.update(toastId, { render: 'Template saved', type: toast.TYPE.SUCCESS, autoClose: 3000 });
          setSubmitting(false);
          props.history.push(`/m1/admin/templates`)
        }).catch(error => {
          toast.update(toastId, { render: `There were some problems, we couldn't save your Template - please check the syntax (${error.data})`, type: toast.TYPE.ERROR, autoClose: 10000 });
          setSubmitting(false);
        });
      }}
      render={({ values, errors, touched, isSubmitting, isValid, setFieldTouched, setFieldValue }) => {
        return (
          <Form>
            <Button
              className='pull-right'
              bsStyle='info' bsSize='small'
              disabled={!isValid}
              onClick={() => sendTest(values)}
            >
              Send Test Email to Yourself
                  </Button>
            <h3 className="first-title">Email Template</h3>
            <div className='row'>
              <div className='col-md-3'>
                <FormikInputControl fieldLabel='Key' fieldName='key' errors={errors} touched={touched} />
                <FormikInputControl fieldLabel='Subject' fieldName='subject' errors={errors} touched={touched} />
                <FormikInputControl fieldLabel='From Name' fieldName='from_name' errors={errors} touched={touched} />
                <FormikInputControl fieldLabel='From Email' fieldName='from_email' errors={errors} touched={touched} />
                <FormikInputControl fieldType='textarea' fieldLabel='Description' fieldName='description' errors={errors} touched={touched} />
                <FormikInputControl fieldLabel='Base Template' fieldName='base_template' errors={errors} touched={touched} />

                <FormikInputControl fieldLabel='Deal ID to merge for Test Email' fieldName='deal_id' errors={errors} touched={touched} />

                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="col-sm-12">
                    <Button bsStyle='default' bsSize='small' onClick={() => props.history.push('/m1/admin/templates')}>Discard Changes</Button>
                    <Button className='pull-right' type='submit' bsStyle='primary' bsSize='small'>Save Changes</Button>
                  </div>
                </div>
              </div>
              <div className='col-md-9'>
                <ul>
                  {/* {this.statebbg.errors.map((e, i) => (<li key={i} className='text-danger'>{e}</li>))} */}
                </ul>
                <div>
                  <div>
                    <AceEditor
                      fontSize={16}
                      showPrintMargin={false}
                      mode="html"
                      theme="clouds"
                      value={recordState.html_content}
                      onChange={(value) => {
                        setRecordState({ ...recordState, html_content: value })
                        setFieldValue('html_content', value)
                      }}
                      name="UNIQUE_ID_OF_DIV"
                      width="100%"
                      height='65vh'
                      tabSize={2}
                      wrapEnabled={true}
                      setOptions={{ indentedSoftWrap: false }}
                      editorProps={{ $blockScrolling: true }}
                    />
                    <ErrorMessage name='html_content' component="div" className="text-danger" />

                  </div>


                </div>

                {/* <div style={{ marginTop: 30, paddingTop: 10, borderTop: '1px solid #bbb' }}>
                  <h2>Example Merge Data</h2>
                  <p>ie. {"{{booking.student_first_name}}"} or {"{{password_welcome_user.dynamic_html.welcome_link}}"}</p>
                  <p>'booking' will be available on all emails related to booking, 'password_welcome_user' and 'password_reset_user' will only be available on the Welcome and Reset templates</p>
                  <pre>



                  </pre>
                </div> */}
              </div>
            </div>

          </Form>)
      }} />

  );
}
export default Template;
